
export type GetCourseDraftId403DetailsItem = {
  /** 필드 이름 */
  field?: string;
  /** 필드별 에러 메시지 */
  message?: string;
};
